import DomRemover from './domRemover'
export default DomRemover
